import { createContext } from "react";

const LayoutContext = createContext({
  controlsRef: null,
});

export default LayoutContext;
